import { differenceInDays, startOfDay } from 'date-fns';

export function remainingDays(date: Date): number {
  return Math.abs(differenceInDays(startOfDay(new Date()), startOfDay(date)));
}
